import { render, staticRenderFns } from "./DashboardShow.vue?vue&type=template&id=087e0888&scoped=true"
import script from "./DashboardShow.vue?vue&type=script&lang=js"
export * from "./DashboardShow.vue?vue&type=script&lang=js"
import style0 from "./DashboardShow.vue?vue&type=style&index=0&id=087e0888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087e0888",
  null
  
)

export default component.exports